import { IoImageOutline } from "react-icons/io5";


const PortalLogoFallback = ({ portalName, isOverlay = false,  }) => (
    <div className={`flex items-center gap-1 px-1.5 py-1 rounded-full ${isOverlay ? 'bg-white/20' : 'bg-gray-100'}`}>
    <IoImageOutline className={`${isOverlay ? 'text-white' : 'text-gray-500'}  w-4 h-4`} />
  </div>
  
  
);

export default PortalLogoFallback;